import { render, staticRenderFns } from "./JobPreferences.vue?vue&type=template&id=37530f2b&scoped=true"
import script from "./JobPreferences.vue?vue&type=script&lang=ts"
export * from "./JobPreferences.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37530f2b",
  null
  
)

export default component.exports